import { isDefined } from "@omni/utils/helper.utils";
import { createContext, MouseEvent, ReactNode, use } from "react";

type HeaderButtonContextValue = {
    isActive: boolean;
    isOverlayOpen: boolean;
    invert: boolean;
    invertMobile: boolean;
    icon: string;
    iconPrefix: string;
    alerts?: string;
    link?: string;
    text?: string;
    hover?: boolean;
    textHidden?: boolean;
    ariaLabel?: string;
    menuElement?: ReactNode;
    hideChevron?: boolean;
    withOverlay: boolean;
    onClick: (event: MouseEvent) => void;
    onCloseMenu: () => void;
};

type HeaderButtonContextProviderProps = {
    isActive: boolean;
    isOverlayOpen: boolean;
    invert: boolean;
    invertMobile: boolean;
    icon: string;
    iconPrefix?: string;
    alerts?: string;
    link?: string;
    text?: string;
    hover?: boolean;
    textHidden?: boolean;
    ariaLabel?: string;
    hideChevron?: boolean;
    menuElement?: ReactNode;
    withOverlay?: boolean;
    onClick: (event: MouseEvent) => void;
    onCloseMenu: () => void;
    children: ReactNode;
};

export const HeaderButtonContext = createContext<
    HeaderButtonContextValue | undefined
>(undefined);

export const HeaderButtonContextProvider = ({
    isActive,
    isOverlayOpen,
    invert,
    invertMobile,
    icon,
    iconPrefix = "las",
    alerts,
    link,
    text,
    hover,
    textHidden,
    ariaLabel,
    menuElement,
    hideChevron,
    withOverlay = false,
    onClick,
    onCloseMenu,
    children
}: HeaderButtonContextProviderProps) => {
    return (
        <HeaderButtonContext
            value={{
                isActive: isActive,
                isOverlayOpen: isOverlayOpen,
                invert: invert,
                invertMobile: invertMobile,
                icon: icon,
                iconPrefix: iconPrefix,
                alerts: alerts,
                link: link,
                text: text,
                hideChevron: hideChevron,
                hover: hover,
                textHidden: textHidden,
                ariaLabel: ariaLabel,
                menuElement: menuElement,
                withOverlay: withOverlay,
                onClick: onClick,
                onCloseMenu: onCloseMenu
            }}
        >
            {children}
        </HeaderButtonContext>
    );
};

export const useHeaderButtonContext = () => {
    const context = use<HeaderButtonContextValue | undefined>(
        HeaderButtonContext
    );

    if (!isDefined(context)) {
        throw new Error(`${HeaderButtonContext.displayName} is undefined.`);
    }

    return context;
};
